import { CircularProgress } from '@mui/material';
import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { SvbrgChatMessageStatus, SvbrgIntakeStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { useUser } from '~/hooks/useUser/useUser';

import { RequestBlocked } from './components/RequestBlocked';
import { RequestSubmit } from './components/RequestSubmit';
import { RequestSubmitted } from './components/RequestSubmitted';
import { useIntakeRequestSubmitState } from './hooks/useIntakeRequestSubmitState';

export const IntakeRequestSubmitStep = ({ role, status, createdBy }: ChatMessageProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestSubmitStep' });
  const { profile } = useUser({ userId: createdBy });

  const { chatSession, demandId, disabled, resubmitDisabled, openDemandDisabled, release, resubmit } =
    useIntakeRequestSubmitState(status);

  if (status === SvbrgChatMessageStatus.PENDING) {
    return (
      <ChatStep
        title={tIntake('IntakeChatStep.assistant')}
        role={role}
        createdBy={createdBy}
        message={t('message.loading')}
        footer={<CircularProgress />}
      />
    );
  }

  if (status === SvbrgChatMessageStatus.COMPLETED && !isNil(demandId)) {
    return (
      <RequestSubmitted
        role={role}
        createdBy={createdBy}
        profile={profile}
        disabled={openDemandDisabled}
        demandId={demandId}
        demandSequenceNumber={chatSession?.demandSequenceNumber}
      />
    );
  }
  if (status === SvbrgChatMessageStatus.COMPLETED && chatSession?.status === SvbrgIntakeStatus.BLOCKED) {
    return <RequestBlocked role={role} createdBy={createdBy} resubmit={resubmit} disabled={resubmitDisabled} />;
  }

  return <RequestSubmit role={role} createdBy={createdBy} profile={profile} disabled={disabled} release={release} />;
};
